export const SUBCATEGORY_POLLING_INTERVAL = 2 * 60 * 1000;
export const SCHEDULING_GROUP_POLLING_INTERVAL = 2 * 60 * 1000;
export const ACCESS_TOKEN_POLLING_INTERVAL = 2 * 60 * 1000;
